import { Route, Routes } from "react-router";
import SideBar from "./sidebar";
import Projects from "./projects";
import Clients from "./clients";
import Tests from "./tests";
import Users from "./users";
import Vendors from "./vendors";
import Logout from "./logout";
import Login from "./login";
import Dashboard from "./dashboard";
import { connect } from "react-redux";
import { setLogin } from "./action";
import Reports from "./reports";
import Archive from "./archive";
import BioWaste from "./biowaste";
window.ulogin="";
window.urole="";
window.uname="";
function App({commondata,setLogin})
{
  return(
    <div>                  
      {commondata.islogin=="Y"?<SideBar/>:""}
      <Routes>
          <Route path="/" element={<Login/>}></Route>          
          <Route path="/dashboard" element={<Dashboard/>}></Route>
          <Route path="/reports" element={<Reports/>}></Route>
          <Route path="/projects" element={<Projects/>}></Route>
          <Route path="/clients" element={<Clients/>}></Route>
          <Route path="/tests" element={<Tests/>}></Route>
          <Route path="/users" element={<Users/>}></Route>
          <Route path="/vendors" element={<Vendors/>}></Route>
          <Route path="/logout" element={<Logout/>}></Route>
          <Route path="/archive" element={<Archive/>}></Route>
          <Route path="/biowaste" element={<BioWaste/>}></Route>
      </Routes>
      <hr/>
      <div className="text-center text-secondary">All Rights Reserved Copyrights CCFT</div>
    </div>
  );
}
let connectToStore=(state)=>({commondata:state});
let dispatchToStore=(dispatch)=>(
    {
        setLogin:(value)=>dispatch(setLogin(value)),
    }
);
export default connect(connectToStore,dispatchToStore)(App);